module.exports = {"230307001":"麻山街道","230307101":"麻山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230307.json
// module id = 711
// module chunks = 0